const WallPaper = () => {
    return (
        <div className="dark:from-transparent dark:to-transparent bg-gradient-to-t from-blue-50 to-blue-100 -z-50 fixed w-full h-full top-0 left-0"></div>
    )
}

export default WallPaper;